import cookie from 'cookie-cutter';

import { clearForms } from '../Forms/duck';

import APICall from '$ReduxLegacy/Actions/APICall';
import Unireducer from '$ReduxLegacy/Reducers/Factories/Unireducer';
import { checkIfFormErrorAndThrow } from '$Utils';

export const loadCookies = function () {
    const company = {};
    const organization = {};

    //origin_path has extra quotes, remove them.

    let originPath = cookie.get('origin_path');

    if (originPath) originPath = originPath.replace(/"/g, '');
    const orgLocked = cookie.get('org_locked') == 1;

    company.name = cookie.get('company');
    company.title = cookie.get('companyName');
    company.logo = cookie.get('companyLogo');
    company.id = cookie.get('companyID');
    company.minimum_age = cookie.get('minimum_age');

    if (company.logo) company.logo = company.logo.replace(/"/g, '');
    organization.type = cookie.get('org_type');
    // cookie is set as 0 or 1 from BE but gets converted to a string, so convert back to boolean
    organization.is_inactive = Boolean(Number(cookie.get('org_is_inactive')));

    if (company.name && company.name.toLowerCase() == 'ahf') {
        company.title = 'AHF Wellness';
    }

    if (company.name && company.name.match(/healthvana/i)) {
        company.name = 'Demo Clinic';
    }
    // Still need non-orgLocked call for the org choose page only
    if (orgLocked) {
        organization.name = cookie.get('reg_org_name');
        organization.name2 = cookie.get('reg_org_name2');
        organization.id = cookie.get('reg_org_id');
        organization.assessment_scheduling = !!cookie.get(
            'assessment_scheduling'
        );
    }

    // cookie returns 0 for false, 1 for true
    const isKiosk = Boolean(cookie.get('kiosk'));

    const payload = {
        company,
        isKiosk,
        organization,
        originPath
    };

    return {
        type: '@@DYNAMIC_INTRODUCTION/CHANGE',
        payload
    };
};

export const logIn = values => dispatch => {
    return dispatch(
        APICall({
            type: 'POST',
            url: '/restapi/ereg/user-login/',
            data: values
        })
    ).then(data => {
        if (data.response && data.response.user_id) {
            return dispatch({
                type: '@@DYNAMIC_INTRODUCTION/CHANGE',
                payload: {
                    loggedIn: true,
                    id: data.response.user_id,
                    email: data.response.email,
                    name: data.response.name
                }
            });
        } else {
            checkIfFormErrorAndThrow(data);
        }
    });
};

export const signUp = values => dispatch => {
    return dispatch(
        APICall({
            type: 'POST',
            url: '/restapi/ereg/user-create/',
            data: values
        })
    ).then(data => {
        if (data.response && data.response.user_id) {
            // First update the introduction state
            return dispatch({
                type: '@@DYNAMIC_INTRODUCTION/CHANGE',
                payload: {
                    loggedIn: true,
                    id: data.response.user_id,
                    email: data.response.email,
                    name: data.response.name
                }
            });
        } else {
            checkIfFormErrorAndThrow(data);
        }
    });
};

export const submitForgotPassword = values => dispatch => {
    return dispatch(
        APICall({
            type: 'POST',
            url: '/api/v2/password-reset-email/',
            data: values
        })
    ).then(data => {
        if (data && data.type === 'API_SUCCESS') {
            return dispatch({
                type: '@@DYNAMIC_INTRODUCTION/CHANGE',
                payload: {
                    forgotPasswordEmail: values.email
                }
            });
        } else {
            checkIfFormErrorAndThrow(data);
        }
    });
};

export const loadOrganizationChoices = companyID => dispatch => {
    // TO DO: Update with Dave's API when we actually get company ID
    return dispatch(
        APICall({
            type: 'GET',
            url: `/api/v2/company/${companyID}/organizations/`
        })
    ).then(data => {
        if (data.response) {
            const organizationChoices = data.response;
            return dispatch({
                type: '@@DYNAMIC_INTRODUCTION/CHANGE',
                payload: { organizationChoices }
            });
        } else {
            return dispatch({
                type: '@@DYNAMIC_INTRODUCTION/CHANGE',
                payload: {
                    orgChoicesError: 'Organization Choices Load Failed'
                }
            });
        }
    });
};

export const chooseOrganization = values => dispatch => {
    return dispatch(
        APICall({
            type: 'POST',
            url: '/restapi/ereg/set-location/',
            data: values
        })
    ).then(data => {
        if (data.response && data.response.status === 'success') {
            return dispatch({
                type: '@@DYNAMIC_INTRODUCTION/CHANGE',
                payload: {
                    organization: {
                        id: data.response.organization_id
                    }
                }
            });
        } else {
            return dispatch({
                type: '@@DYNAMIC_INTRODUCTION/CHANGE',
                payload: {
                    setOrgError: 'Organization Choice Save Failed'
                }
            });
        }
    });
};

export const logOut = () => (dispatch, getState) => {
    dispatch(clearForms());
    const { originPath } = getState().introduction;
    // Clear everything except origin path from Redux.
    // Upon hitting origin path, new cookies will be assigned.
    dispatch({
        type: '@@DYNAMIC_INTRODUCTION/CHANGE',
        payload: Object.assign({}, _initialState, {
            originPath
        })
    });
    return dispatch(
        APICall({
            type: 'GET',
            // This causes an error in Storybook/Chromatic, so ignore it.
            // TODO: If we find a better way to handle this with Chromatic, can remove this check.
            url: !process.env.STORYBOOK_ENV
                ? '/registration/reset-session/'
                : ''
        })
    ).catch(error => {
        console.error('Logout Failed.', error);
    });
};

export const _initialState = {
    company: null,
    email: null,
    id: null,
    loggedIn: false,
    minimum_age: null,
    newUser: null,
    originPath: null,
    organization: null,
    organizationChoices: null,
    orgChoicesError: null,
    orgChoices: null,
    setOrgError: null,
    username: null,
    termsOfService: null,
    privacyPolicy: null,
    forgotPasswordEmail: null,
    name: null,
    isKiosk: false
};

export default Unireducer('@@DYNAMIC_INTRODUCTION', _initialState);
